/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import OrderConfirmation from './order-confirmation';
import OrderConfirmationView from './order-confirmation.view';

export * from './components';
export * from './order-confirmation';
export * from './order-confirmation.data';
export * from './order-confirmation.props.autogenerated';
export * from './order-confirmation.view';

export {
    OrderConfirmation,
    OrderConfirmationView
};
